import React from 'react';
import FieldActions from '../fieldactions';

import AddFieldDialog from './add';
import RenameFieldDialog from './rename';
import DeleteFieldDialog from './delete';

const DialogsForActions = {
	[FieldActions.Add]: AddFieldDialog,
	[FieldActions.Rename]: RenameFieldDialog,
	[FieldActions.Delete]: DeleteFieldDialog
}

const EditDialogs = React.memo(props => {
	const { fieldActionRequest } = props;
	const Dialog = DialogsForActions[fieldActionRequest.action];
	const d = Dialog ? (
			<Dialog 
				{...props}
				open={true} 
				/>
	) : null;

	return d;
});

export function dialogForAction(action) {
	return DialogsForActions[action];
}

export default EditDialogs;